import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { collection, getDocs, query, where, addDoc, serverTimestamp } from 'firebase/firestore'; 
import { useNavigate } from 'react-router-dom';
import { statesAndDistricts } from '../data/indianStates';
import Preloader from '../components/Preloader';
import AdBanner from '../components/AdBanner'; 

const skillCategories = [
  "Electrician", "Plumber", "Carpenter", "Painter", "Rajmistri (Mason)", "Labour", 
  "Welder", "Tiles Mistry", "Driver", "Mechanic", "Pop","Gardner", "Hotel Worker", 
  "Ac & Fridge Machenic", "WashingMachine Machenic", "WatchMan"
];

const FindWorkers = () => {
  const navigate = useNavigate();
  const [workers, setWorkers] = useState([]);
  const [filteredWorkers, setFilteredWorkers] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [viewType, setViewType] = useState('workers'); 
  const [showLoginModal, setShowLoginModal] = useState(false);

  const [showThekedarDetails, setShowThekedarDetails] = useState(false);
  const [selectedThekedar, setSelectedThekedar] = useState(null);
  const [thekedarLabours, setThekedarLabours] = useState([]);
  const [labourLoading, setLabourLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [availableDistricts, setAvailableDistricts] = useState([]);
  const [stateSearch, setStateSearch] = useState('');
  const [districtSearch, setDistrictSearch] = useState('');

  // ✅ FETCH DATA WITH HIRE FILTER
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setWorkers([]);
      setFilteredWorkers([]);

      try {
        let dataList = [];

        if (viewType === 'workers') {
            const q = collection(db, "workers");
            const querySnapshot = await getDocs(q);
            dataList = querySnapshot.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                // ✅ HIRE FILTER: Sirf unko dikhao jo hire nahi hue hain (!isHired)
                .filter(item => !item.isThekedar && item.isHired !== true); 
        } 
        else {
            const usersQuery = query(collection(db, "users"), where("isThekedar", "==", true));
            const usersSnap = await getDocs(usersQuery);
            const userThekedars = usersSnap.docs.map(doc => ({ id: doc.id, ...doc.data(), type: 'Agent' }));

            const workersQuery = query(collection(db, "workers"), where("isThekedar", "==", true));
            const workersSnap = await getDocs(workersQuery);
            const workerThekedars = workersSnap.docs.map(doc => ({ id: doc.id, ...doc.data(), type: 'Verified Worker' }));

            dataList = [...userThekedars, ...workerThekedars];
        }

        setWorkers(dataList);
        setFilteredWorkers(dataList);
      } catch (error) { console.error("Error fetching data:", error); }
      setLoading(false);
    };
    fetchData();
  }, [viewType]);

  // ✅ FILTER LOGIC (Remains Same)
  useEffect(() => {
    let result = workers;
    if (searchTerm) {
      const lower = searchTerm.toLowerCase();
      result = result.filter(item => 
        (item.name && item.name.toLowerCase().includes(lower)) ||
        (item.thekedarType && item.thekedarType.toLowerCase().includes(lower)) || 
        (item.skills && item.skills.some(s => s.toLowerCase().includes(lower)))
      );
    }
    if (selectedCategory && viewType === 'workers') {
      result = result.filter(worker => (Array.isArray(worker.skills) ? worker.skills.includes(selectedCategory) : worker.category === selectedCategory));
    }
    if (selectedState) result = result.filter(item => item.state === selectedState);
    if (selectedDistrict) result = result.filter(item => item.district === selectedDistrict);

    setFilteredWorkers(result);
  }, [searchTerm, selectedCategory, selectedState, selectedDistrict, workers, viewType]);

  const handleStateChange = (e) => {
    const state = e.target.value;
    setSelectedState(state);
    setAvailableDistricts(statesAndDistricts[state] || []);
    setSelectedDistrict(''); setDistrictSearch(''); 
  };

  const handleCardClick = async (item) => {
    if (!auth.currentUser) { setShowLoginModal(true); return; }

    try {
        const targetUserId = item.uid || item.id; 
        if (targetUserId && targetUserId !== auth.currentUser.uid) {
            await addDoc(collection(db, "notifications"), {
                toUserId: targetUserId,
                fromUserId: auth.currentUser.uid,
                fromUserName: auth.currentUser.displayName || "A Customer",
                fromUserPhone: auth.currentUser.phoneNumber || "",
                type: 'profile_view',
                message: "Kisi ne abhi aapki profile dekhi hai! 🚀",
                read: false,
                timestamp: serverTimestamp()
            });
        }
    } catch (error) { console.error("Notification Error:", error); }
    
    if (viewType === 'workers') {
        navigate(`/worker/${item.id}`);
    } else {
        setSelectedThekedar(item);
        setShowThekedarDetails(true);
        setLabourLoading(true);
        setThekedarLabours([]);
        try {
            const q = query(collection(db, "workers"), where("assignedThekedarId", "==", item.id));
            const querySnapshot = await getDocs(q);
            const labourList = querySnapshot.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                // ✅ HIRE FILTER FOR TEAM: Team mein bhi hired workers nahi dikhenge
                .filter(w => w.isHired !== true); 
            setThekedarLabours(labourList);
        } catch (error) { console.error("Error fetching labour:", error); }
        setLabourLoading(false);
    }
  };

  if (loading) return <Preloader />;

  const filteredStatesList = Object.keys(statesAndDistricts).filter(state => state.toLowerCase().includes(stateSearch.toLowerCase()));
  const filteredDistrictsList = availableDistricts.filter(dist => dist.toLowerCase().includes(districtSearch.toLowerCase()));

  return (
    <div className="min-h-screen bg-slate-50 pb-10 flex flex-col" style={{ paddingTop: '40px' }}>
      
      {/* 1. LOGIN MODAL */}
      {showLoginModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 animate-fade-in px-6">
            <div className="bg-white rounded-[2rem] p-6 w-full max-w-sm text-center">
                <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center text-3xl mx-auto mb-4">🔒</div>
                <h2 className="text-2xl font-extrabold text-slate-800 mb-2">Login Required</h2>
                <p className="text-slate-500 mb-4 text-sm">Please login to view details.</p>
                <button onClick={() => navigate('/signup')} className="w-full bg-blue-600 text-white py-3 rounded-xl font-bold">Login Now</button>
                <button onClick={() => setShowLoginModal(false)} className="w-full mt-2 text-slate-400 text-sm">Close</button>
            </div>
        </div>
      )}

      {/* 2. THEKEDAR DETAILS & LABOUR LIST MODAL */}
      {showThekedarDetails && selectedThekedar && (
          <div className="fixed inset-0 z-[100] flex items-end md:items-center justify-center bg-black/90 backdrop-blur-md p-0 md:p-4 animate-fade-in">
              <div className="bg-slate-50 w-full md:max-w-md h-[85vh] md:h-auto md:max-h-[80vh] rounded-t-[2.5rem] md:rounded-[2rem] shadow-2xl relative flex flex-col overflow-hidden">
                  <div className="bg-slate-900 p-6 pb-8 text-white relative shrink-0">
                      <button onClick={() => setShowThekedarDetails(false)} className="absolute top-4 right-4 bg-white/10 w-8 h-8 rounded-full flex items-center justify-center text-white text-sm hover:bg-red-500 transition">✕</button>
                      <div className="flex items-center gap-4">
                          <div className="w-16 h-16 bg-yellow-400 rounded-2xl flex items-center justify-center text-3xl text-black font-bold shadow-lg">👑</div>
                          <div>
                              <h2 className="text-2xl font-bold">{selectedThekedar.name}</h2>
                              <p className="text-yellow-400 font-bold text-xs uppercase tracking-wide bg-white/10 px-2 py-1 rounded-md inline-block mt-1">{selectedThekedar.thekedarType} Contractor</p>
                          </div>
                      </div>
                      <a href={`tel:${selectedThekedar.mobile}`} className="mt-6 bg-green-500 text-white w-full py-3 rounded-xl font-bold flex items-center justify-center gap-2 shadow-lg hover:bg-green-600 transition">📞 Call Thekedar Now</a>
                  </div>

                  <div className="p-6 overflow-y-auto flex-grow bg-slate-50">
                      <h3 className="text-slate-800 font-bold text-lg mb-4 flex items-center gap-2">👷 Team Members <span className="bg-slate-200 text-slate-600 text-xs px-2 py-0.5 rounded-full">{thekedarLabours.length}</span></h3>
                      {labourLoading ? (
                          <div className="text-center py-10"><div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto"></div></div>
                      ) : (
                          <div className="space-y-3">
                              {thekedarLabours.length > 0 ? (
                                  thekedarLabours.map(worker => (
                                      <div key={worker.id} className="bg-white p-3 rounded-xl border border-slate-200 shadow-sm flex items-center gap-3">
                                          <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center text-xl">👷</div>
                                          <div className="flex-1">
                                              <h4 className="font-bold text-slate-800 text-sm">{worker.name}</h4>
                                              <p className="text-xs text-slate-500">{worker.skills[0]} • ₹{worker.wage}/day</p>
                                          </div>
                                          <a href={`tel:${worker.mobile}`} className="bg-blue-100 text-blue-600 p-2 rounded-lg text-xs font-bold">📞 Call</a>
                                      </div>
                                  ))
                              ) : (
                                  <div className="text-center py-10 text-slate-400 border-2 border-dashed border-slate-200 rounded-2xl"><p>No available workers in team.</p></div>
                              )}
                          </div>
                      )}
                  </div>
              </div>
          </div>
      )}

      {/* HERO HEADER */}
      <div className="bg-slate-900 pt-10 pb-16 px-4 rounded-b-[2.5rem] shadow-2xl mb-6 relative overflow-hidden shrink-0">
        <div className="absolute top-0 left-0 w-full h-full opacity-30 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
        <div className="relative z-10 max-w-4xl mx-auto">
          <div className="text-center mb-6">
            <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight tracking-tight drop-shadow-lg">Find <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-yellow-400 to-orange-400">Workforce</span></h1>
            <div className="flex justify-center mt-6">
                <div className="bg-slate-800 p-1.5 rounded-2xl inline-flex border border-slate-700 shadow-lg">
                    <button onClick={() => setViewType('workers')} className={`px-6 py-2.5 rounded-xl text-sm font-bold transition-all flex items-center gap-2 ${viewType === 'workers' ? 'bg-blue-600 text-white shadow-md' : 'text-slate-400 hover:text-white'}`}>👷 Workers</button>
                    <button onClick={() => setViewType('thekedars')} className={`px-6 py-2.5 rounded-xl text-sm font-bold transition-all flex items-center gap-2 ${viewType === 'thekedars' ? 'bg-yellow-400 text-black shadow-md' : 'text-slate-400 hover:text-white'}`}>👑 Thekedars</button>
                </div>
            </div>
          </div>
          <div className="bg-white/10 backdrop-blur-md border border-white/20 p-2 rounded-2xl shadow-xl flex flex-col md:flex-row gap-2 max-w-3xl mx-auto mb-4">
            <input type="text" placeholder={viewType === 'workers' ? "🔍 Search Name, Skill..." : "🔍 Search Thekedar Name..."} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="flex-grow p-3 bg-white rounded-xl outline-none text-slate-700 font-bold placeholder-slate-400" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
            {viewType === 'workers' && (
                <div className="col-span-1">
                    <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} className="w-full px-4 py-3 rounded-xl bg-yellow-400 text-slate-900 font-bold border-2 border-yellow-500 outline-none shadow-md appearance-none text-center cursor-pointer">
                    <option value="">🛠️ All Categories</option>{skillCategories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                    </select>
                </div>
            )}
            <div className={`bg-slate-800 p-2 rounded-xl border border-slate-700 ${viewType === 'thekedars' ? 'col-span-1 md:col-span-2' : 'col-span-1'}`}>
                <input type="text" placeholder="🔎 Type State..." value={stateSearch} onChange={(e) => setStateSearch(e.target.value)} className="w-full bg-slate-700 text-white text-xs p-2 rounded-lg mb-1 outline-none text-center placeholder-slate-400" />
                <select value={selectedState} onChange={handleStateChange} className="w-full bg-slate-800 text-white font-bold outline-none text-sm text-center cursor-pointer">
                    <option value="">📍 Select State</option>{filteredStatesList.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
            </div>
            <div className="col-span-1 bg-slate-800 p-2 rounded-xl border border-slate-700">
                <input type="text" placeholder="🔎 Type District..." value={districtSearch} onChange={(e) => setDistrictSearch(e.target.value)} className="w-full bg-slate-700 text-white text-xs p-2 rounded-lg mb-1 outline-none text-center placeholder-slate-400" />
                <select value={selectedDistrict} onChange={(e) => setSelectedDistrict(e.target.value)} className="w-full bg-slate-800 text-white font-bold outline-none text-sm text-center cursor-pointer">
                    <option value="">🏙️ Select District</option>{filteredDistrictsList.map(d => <option key={d} value={d}>{d}</option>)}
                </select>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 flex-grow w-full">
        <h2 className="text-lg font-bold text-slate-800 mb-4">Available {viewType === 'workers' ? 'Workers' : 'Contractors'} ({filteredWorkers.length})</h2>
        {filteredWorkers.length === 0 ? (
          <div className="text-center py-16 bg-white rounded-3xl border border-dashed border-slate-300 mx-4">
            <div className="text-5xl mb-3">😕</div>
            <p className="text-lg font-bold text-slate-700">No {viewType} available.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pb-8">
            {filteredWorkers.map(item => (
              <div key={item.id} onClick={() => handleCardClick(item)} className={`group cursor-pointer bg-white rounded-2xl p-4 shadow-sm hover:shadow-xl transition-all duration-300 border active:scale-[0.98] flex flex-row items-center gap-4 relative overflow-hidden ${viewType === 'thekedars' ? 'border-yellow-300 ring-1 ring-yellow-100' : 'border-slate-100'}`}>
                  {viewType === 'thekedars' && <div className="absolute top-0 right-0 bg-yellow-400 text-[10px] font-bold px-2 py-1 rounded-bl-lg shadow-sm z-10">👑 Verified {item.thekedarType}</div>}
                  <div className={`absolute left-0 top-0 bottom-0 w-1.5 ${viewType === 'thekedars' ? 'bg-yellow-400' : 'bg-blue-500'} rounded-l-2xl`}></div>
                  <img src={item.imageUrl || "https://cdn-icons-png.flaticon.com/512/9187/9187604.png"} alt={item.name} className="w-20 h-20 rounded-xl object-cover shadow-sm bg-slate-100 shrink-0" />
                  <div className="flex-grow min-w-0">
                    <h3 className="font-bold text-slate-800 text-lg truncate">{item.name}</h3>
                    <p className="text-xs text-slate-500 mb-2 truncate">📍 {item.village ? item.village + ', ' : ''} {item.district}</p>
                    <div className="flex flex-wrap gap-1">
                        {viewType === 'workers' ? <span className="text-[10px] font-bold bg-blue-50 text-blue-600 px-2 py-0.5 rounded">{item.skills ? item.skills[0] : item.category}</span> : <span className="text-[10px] font-bold bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded uppercase">{item.thekedarType || "Contractor"}</span>}
                    </div>
                    <div className="flex justify-between items-center border-t border-slate-100 pt-2 mt-1">
                        {viewType === 'workers' ? <p className="font-bold text-slate-900 text-sm">₹{item.wage}/day</p> : <p className="font-bold text-slate-900 text-xs">📞 Click for Details</p>}
                        <span className={`text-xs font-bold ${viewType === 'thekedars' ? 'text-yellow-600' : 'text-blue-600'}`}>View ➔</span>
                    </div>
                  </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {/* ==================== ADSENSE CONTENT START ==================== */}
      <div className="w-full bg-white mt-12 py-12 border-t border-slate-200">
        <div className="max-w-6xl mx-auto px-4">
          
          {/* Services Section */}
          <div className="mb-12">
            <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-8 text-center">
              Available Construction Services 🛠️
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="p-5 bg-slate-50 rounded-xl border border-slate-100">
                <h3 className="font-bold text-blue-700 mb-2">Skilled Rajmistri</h3>
                <p className="text-sm text-slate-600">Expert masons for brickwork, plastering, and foundation. Verified workers for strong construction.</p>
              </div>
              <div className="p-5 bg-slate-50 rounded-xl border border-slate-100">
                <h3 className="font-bold text-blue-700 mb-2">Tiles & Marble</h3>
                <p className="text-sm text-slate-600">Professional flooring experts for granite, marble, and wall tiles fitting with precision.</p>
              </div>
              <div className="p-5 bg-slate-50 rounded-xl border border-slate-100">
                <h3 className="font-bold text-blue-700 mb-2">Painters & POP</h3>
                <p className="text-sm text-slate-600">Interior and exterior house painting, putty work, and false ceiling designs by experienced painters.</p>
              </div>
              <div className="p-5 bg-slate-50 rounded-xl border border-slate-100">
                <h3 className="font-bold text-blue-700 mb-2">Plumbers & Electricians</h3>
                <p className="text-sm text-slate-600">Licensed electricians for wiring and experienced plumbers for sanitary fitting and repairs.</p>
              </div>
              <div className="p-5 bg-slate-50 rounded-xl border border-slate-100">
                <h3 className="font-bold text-blue-700 mb-2">Carpenters (Badhai)</h3>
                <p className="text-sm text-slate-600">Woodwork experts for furniture making, door/window fitting, and modular kitchen work.</p>
              </div>
              <div className="p-5 bg-slate-50 rounded-xl border border-slate-100">
                <h3 className="font-bold text-blue-700 mb-2">Labour & Helpers</h3>
                <p className="text-sm text-slate-600">Hardworking daily wage labourers for material shifting, mixing, and site assistance.</p>
              </div>
            </div>
          </div>

          {/* Educational Content */}
          <div className="bg-slate-50 p-6 md:p-10 rounded-3xl">
            <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-6">
              Why Use KaamSetu for Hiring? ✅
            </h2>
            <div className="space-y-4 text-slate-700">
              <p>
                <strong>1. Verified Workers:</strong> Safety is our priority. We verify the identity and skills of workers so you can hire with confidence.
              </p>
              <p>
                <strong>2. Direct Connection:</strong> No middlemen needed. Contact the workers or contractors directly and negotiate your own rates.
              </p>
              <p>
                <strong>3. Local Search:</strong> Find workers in your specific District or Village. This saves travel time and ensures work starts immediately.
              </p>
              <p className="pt-4 text-sm text-slate-500">
                KaamSetu is India's fastest-growing platform for the construction workforce. Whether you need a daily wager or a full contractor team, we bridge the gap effectively.
              </p>
            </div>
          </div>

        </div>
      </div>
      {/* ==================== ADSENSE CONTENT END ==================== */}
      
      <div className="max-w-4xl mx-auto px-4 mt-8 mb-4 w-full"><p className="text-center text-[10px] text-slate-300 uppercase tracking-widest mb-2">Sponsored</p><AdBanner /></div>
    </div>
  );
};

export default FindWorkers;